/**
 * The learner's Home's one way out to My sessions (issue #465, part 1a). The
 * teaching Home reaches My sessions from its week register's head instead.
 * The shell that renders decides the path and nothing else.
 */
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

/**
 * The control takes its height from the kit (`--control-height`, which is the
 * 44 px floor on a coarse pointer), so no literal height rides on it.
 *
 * `-ms-4` below `md` pulls the ghost button's own padding back so its LABEL,
 * not its box, lines up with the heading text above it. `.page-heading` stacks
 * its children at `max-width: 767px` — Tailwind's `md` boundary exactly — and
 * left-aligns them, at which point the untouched padding reads as a stray
 * indent on the one control in the column. Above `md` the control sits
 * opposite the title and its padding is simply padding.
 */
export function SeatAllClassesLink({ basePath }: { basePath: string }) {
  return (
    <Button asChild variant="ghost" className="-ms-4 md:ms-0">
      <Link to={`${basePath}/sessions`}>My sessions</Link>
    </Button>
  );
}
